import {Create} from "react-admin";
import {QuizAssessmentQuestionForm} from "./component/quiz-assessment-question.form";

export function QuizAssessmentQuestionCreate(props) {
  return (
    <>
      <Create {...props}>
        <QuizAssessmentQuestionForm />
      </Create>
    </>
  )
}
